export enum ClaimType {
    PartsIssue = "PartsIssue",
    FreightOnly = "FreightOnly",
    ExtraParts = "ExtraParts",
}
